import React from 'react';
import IdentifySidebarListItem from './identify-sidebar-list-item';
import classnames from 'classnames';

class IdentifySidebarList extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      expanded: true
    }
    this.toggleExpanded = this.toggleExpanded.bind(this);
    this.renderList = this.renderList.bind(this);
  }

  toggleExpanded(e){
    this.setState({expanded: !this.state.expanded})
  }

  renderList(features){
    const { expanded } = this.state;
    if(!expanded) return null;
    if(!features.length) return (
      <div>
        No features at this location
      </div>
    );
    return (
      <ul className="list-group">
        {
          features.map((feature, i) => {
            return <IdentifySidebarListItem feature={feature} key={i} />
          })
        }
      </ul>
    )
  }

  render(){
    const { expanded } = this.state;
    const { displayName, features } = this.props;

    const expanderClass = classnames({
      'mdi': true,
      'mdi-menu-right': !expanded,
      'mdi-menu-down': expanded,
      'icon-inline': true
    })

    return (
      <div>
        <div 
          onClick={ this.toggleExpanded } 
          className="overflow-ellipsis" 
          style={{cursor:'pointer', whiteSpace:'nowrap'}}>
            <i className={ expanderClass }></i><strong>{ displayName }</strong>
        </div>
        { this.renderList(features) }
      </div>
    )
  }
}

export default IdentifySidebarList;